import { getLanguages } from '../../../../app/src/views/profile/myProfile/getLanguages.js';

const METADATA_DATETIME = {
  parse: "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'",
  format: 'datetimelong',
};

export function getView() {
  return {
    options: {},
    model: 'form',
    properties: [
      {
        name: 'SECTION_ACCOUNT',
        title: edicom.locale.translate('enrollment.eidas.account.title'),
        type: 'collapse',
        metadata: { open: true },
        properties: [
          {
            title: edicom.locale.translate('userProfile.field_email'),
            model: 'form.email',
            type: 'string',
            metadata: {
              maxlength: 70,
              type: 'email',
            },
            required: true,
            cols: 4,
          },
          {
            type: 'select',
            title: edicom.locale.translate('userProfile.field_language'),
            model: 'form.language',
            metadata: {
              autocomplete: true,
              allowInvalid: false,
              options: getLanguages(),
            },
            cols: 4,
          },
        ],
      },
      {
        name: 'SECTION_CERT',
        title: edicom.locale.translate('enrollment.eidas.cert.title'),
        type: 'collapse',
        metadata: { open: true },
        properties: [
          {
            title: edicom.locale.translate('enrollment.eidas.cert.subject'),
            model: 'form.certDataSubject',
            type: 'string',
            disabled: true,
            cols: 4,
          },
          {
            title: edicom.locale.translate('enrollment.eidas.cert.emisor'),
            model: 'form.certDataIssuer',
            type: 'string',
            disabled: true,
            cols: 4,
          },
          {
            title: edicom.locale.translate('enrollment.eidas.cert.numserie'),
            model: 'form.certDataSerialNumber',
            type: 'string',
            disabled: true,
            cols: 2,
          },
          {
            title: edicom.locale.translate('enrollment.eidas.cert.signature'),
            model: 'form.certDataSignature',
            type: 'string',
            disabled: true,
            cols: 2,
          },
          {
            title: edicom.locale.translate('enrollment.eidas.cert.validFrom'),
            model: 'form.certDataValidFrom',
            type: 'date-time',
            metadata: METADATA_DATETIME,
            disabled: true,
            cols: 2,
          },
          {
            title: edicom.locale.translate('enrollment.eidas.cert.validUntil'),
            model: 'form.certDataValidUntil',
            type: 'date-time',
            metadata: METADATA_DATETIME,
            disabled: true,
            cols: 2,
          },
        ],
      },
      {
        name: 'SECTION_USER',
        title: edicom.locale.translate('enrollment.eidas.user.title'),
        type: 'collapse',
        metadata: { open: true },
        properties: [
          {
            title: edicom.locale.translate('enrollment.eidas.user.nif'),
            model: 'form.nif',
            type: 'string',
            disabled: true,
            cols: 2,
          },
          {
            title: edicom.locale.translate('enrollment.eidas.user.name'),
            model: 'form.name',
            type: 'string',
            metadata: {
              maxlength: 50,
            },
            required: true,
            cols: 2,
          },
          {
            title: edicom.locale.translate('enrollment.eidas.user.apellidos'),
            model: 'form.surnames',
            type: 'string',
            metadata: {
              maxlength: 50,
            },
            cols: 4,
          },
          {
            title: edicom.locale.translate('enrollment.eidas.user.direccion'),
            model: 'form.address',
            type: 'string',
            metadata: {
              maxlength: 50,
            },
            required: true,
            cols: 4,
          },
          {
            title: edicom.locale.translate('enrollment.eidas.user.poblacion'),
            model: 'form.city',
            type: 'string',
            metadata: {
              maxlength: 50,
            },
            required: true,
            cols: 4,
          },
          {
            title: edicom.locale.translate('enrollment.eidas.user.provincia'),
            model: 'form.state',
            type: 'string',
            metadata: {
              maxlength: 50,
            },
            required: true,
            cols: 4,
          },
          {
            title: edicom.locale.translate('enrollment.eidas.user.cp'),
            model: 'form.postalCode',
            type: 'string',
            metadata: {
              maxlength: 50,
            },
            required: true,
            cols: 2,
          },
        ],
      },
    ],
  };
}
